import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from "react-i18next";
import {FormHelperText} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import InputAtm from '../../atomic/Input/Input';

// Şifre alanı + altında tek satır: solda doğrulama hatası, sağda göster/gizle.
const PasswordInput = ({name, id, label, error, inputRef, autoComplete}) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const inputId = id || name;

    return (
        <>
            <InputAtm
                id={inputId}
                name={name}
                type={visible ? "text" : "password"}
                variant="outlined"
                label={label}
                fullWidth
                autoComplete={autoComplete}
                error={!!error}
                inputRef={inputRef}
            />
            <div className="password-input__meta">
                <FormHelperText error={!!error}>
                    {error && error.message}
                </FormHelperText>
                <button
                    type="button"
                    className="password-input__toggle"
                    aria-controls={inputId}
                    // Yazarken tıklanınca imleç inputta kalsın
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => setVisible(!visible)}
                >
                    {visible ? <VisibilityOff /> : <Visibility />}
                    {visible
                        ? t('enw-input-hide_password', 'Şifreyi gizle')
                        : t('enw-input-show_password', 'Şifreyi göster')}
                </button>
            </div>
        </>
    );
};

PasswordInput.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.object,
    inputRef: PropTypes.any,
    autoComplete: PropTypes.string,
};

export default PasswordInput;
